// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6581":"1acdb66b","8198":"79bc7ba5"}[chunkId] + ".chunk.css";
};